import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import HeroSection from './components/HeroSection';
import VisioneSection from './components/VisioneSection';
import TerritorioSection from './components/TerritorioSection';
import ReportSection from './components/ReportSection';
import BorghiSection from './components/BorghiSection';
import PerChiSection from './components/PerChiSection';
import ContattiSection from './components/ContattiSection';
import Footer from '@/components/feature/Footer';
import ProgettoModal from '@/components/feature/ProgettoModal';
import SeoHead from '@/components/feature/SeoHead';
import TestimonialsSection from './components/TestimonialsSection';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://www.discoveringmarche.com';

const HOME_JSONLD = [
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'Discovering Marche',
    url: SITE_URL,
    description: 'Scopri i borghi storici delle Marche: Castelfidardo, Riviera del Conero, borghi medievali. Guida al territorio, immobili e qualità della vita nelle Marche.',
    potentialAction: {
      '@type': 'SearchAction',
      target: `${SITE_URL}/borghi?q={search_term_string}`,
      'query-input': 'required name=search_term_string',
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    name: 'Discovering Marche — Ines Felicity Di Nallo',
    description: 'Scopri i borghi storici delle Marche con Discovering Marche. Territorio, immobili, cultura e qualità della vita nelle Marche.',
    url: SITE_URL,
    logo: 'https://public.readdy.ai/ai/img_res/49b48721-69a4-4c7d-8e06-4224313d172b.png',
    address: {
      '@type': 'PostalAddress',
      addressLocality: 'Castelfidardo',
      addressRegion: 'AN',
      addressCountry: 'IT',
    },
    areaServed: 'Marche, Italy',
    knowsLanguage: ['it', 'en', 'es'],
    sameAs: ['https://www.instagram.com/felicity.dinallo_/'],
    employee: {
      '@type': 'Person',
      name: 'Ines Felicity Di Nallo',
      jobTitle: 'Agente Immobiliare Abilitata — CCIAA Ancona',
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'Home', item: SITE_URL },
    ],
  },
];

const Home = () => {
  const [progettoOpen, setProgettoOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      // Wait for DOM to be ready then scroll
      const timer = setTimeout(() => {
        const el = document.querySelector(location.hash);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 200);
      return () => clearTimeout(timer);
    }
  }, [location]);

  return (
    <main className="min-h-screen">
      <SeoHead
        title="Discovering Marche — Borghi Storici, Immobili e Territorio nelle Marche"
        description="Discovering Marche: scopri i borghi storici delle Marche, immobili nei borghi medievali, territorio e qualità della vita. Castelfidardo, Riviera del Conero, Osimo, Sirolo."
        keywords="borghi Marche, immobili borghi Marche, Castelfidardo real estate, Riviera del Conero, vivere nelle Marche"
        canonical="/"
        jsonLd={HOME_JSONLD}
      />
      <Navbar onProgettoClick={() => setProgettoOpen(true)} transparent />

      <HeroSection />
      <VisioneSection />
      <TerritorioSection />
      <ReportSection />
      <BorghiSection />
      <PerChiSection />
      <TestimonialsSection />
      <ContattiSection />
      <Footer onProgettoClick={() => setProgettoOpen(true)} />

      <ProgettoModal
        isOpen={progettoOpen}
        onClose={() => setProgettoOpen(false)}
      />
    </main>
  );
};

export default Home;
